import React from 'react';
import { Link } from 'react-router-dom';

const News = ({ viewModel }) => (
	<section className="press-and-numbers">
		<div className={` marketing-page`}>
			<div className="news-logo-links-container">
				<ul className={`news-logo-links mb-0`}>
					{viewModel !== 'mobile' && (
						<li className={`item`}>
							<div>
								<a
									className={`link-${viewModel} bbb mr-1`}
									href="http://www.bbb.org/new-york-city/business-reviews/advertising-directory-and-guide/unpakt-llc-in-new-york-ny-139111/"
									target="_blank"
									rel="noopener noreferrer">
									<img
										src={`${process.env.REACT_APP_CDN_IMAGES}/home/bbb-grade.png`}
										alt="better business bureau"
										height={30}
									/>
								</a>
							</div>
						</li>
					)}
					<li className={`item tnw`}>
						<a
							className={`link link-${viewModel}`}
							href="https://thenextweb.com/news/moving-company-comparison-site-unpakt-launches-tool-instant-quotes"
							target="_blank"
							rel="noopener noreferrer">
							The Next Web
						</a>
					</li>
					<li className={`item tc`}>
						<a
							className={`link link-${viewModel}`}
							href="https://techcrunch.com/2013/01/02/unpakt-moving-companies/"
							target="_blank"
							rel="noopener noreferrer">
							TechCrunch
						</a>
					</li>
					<li className={`item cnbc`}>
						<a
							className={`link link-${viewModel}`}
							href="https://www.cnbc.com/id/100620122"
							target="_blank"
							rel="noopener noreferrer">
							CNBC
						</a>
					</li>
					<li className={`item forbes`}>
						<a
							className={`link link-${viewModel}`}
							href="https://www.forbes.com/sites/karstenstrauss/2013/02/19/a-startup-to-take-the-sting-out-of-moving/"
							target="_blank"
							rel="noopener noreferrer">
							Forbes
						</a>
					</li>
					<li className={`item cnn`}>
						<a
							className={`link link-${viewModel}`}
							href="https://edition.cnn.com/2014/08/18/tech/web/unpakt-moving/"
							target="_blank"
							rel="noopener noreferrer">
							CNN
						</a>
					</li>
					{viewModel !== 'mobile' && (
						<li className={`item`}>
							<Link
								className={`link read-more link-${viewModel}`}
								to="/press-page/">
								Unpakt Press
							</Link>
						</li>
					)}
				</ul>
			</div>
		</div>

		<style jsx>{`
			.item {
				display: inline-block;
				padding: 0 10px;
				vertical-align: middle;
			}
			.item:not(:last-child) {
				padding-right: 1rem;
			}
			.news-logo-links {
				padding: 0;
				margin-left: 0;
				text-align: center;
			}
			.link {
				width: auto;
				height: 44px;
				display: block;
				background: url('${process.env
						.REACT_APP_CDN_IMAGES}/non-funnel/vendors/news.png')
					no-repeat 0 0;
				overflow: hidden;
				text-indent: -999px;
				margin-right: 0;
				transform: scale(0.6);
				margin: 0 -1rem;
			}

			.tnw .link {
				width: 90px;
				background-position: 0 0;
			}
			.tc .link {
				width: 146px;
				background-position: -121px 0;
			}
			.thp .link {
				width: 110px;
				background-position: -294px -2px;
			}
			.cnbc .link {
				width: 62px;
				background-position: -430px 0;
			}
			.forbes .link {
				width: 108px;
				background-position: -525px 0;
			}
			.cnn .link {
				width: 70px;
				background-position: -666px 0;
			}

			/////////////  Desktop/Wide   /////////////

			.link,
			.bbb {
				filter: grayscale(1);
				opacity: 0.6;
				transition: all 0.5s;
			}
			.link:hover,
			.bbb:hover {
				filter: grayscale(0);
				opacity: 1;
				text-decoration: none;
			}
			.link:hover {
				border: none;
			}

			.link-mobile {
				transform: scale(0.4);
				margin: 0 -1.8rem;
			}
		`}</style>
	</section>
);

export default News;
